import React, { useRef, useState } from 'react';
import { Box, Grid } from '@material-ui/core';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import TextWithClicks from 'src/pages/reportUsage/common/textWithClicks/TextWithClicks';
import { sizes } from 'src/styles/Media.styled';
import { makeStyles } from '@material-ui/core/styles';
import { PriceOverrideAlert } from 'src/pages/reportUsage/submit/components/submissionComplete.styled';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import PoInfoView from 'src/pages/reportUsage/record/components/reportPayment/PoInfoView';
import {
    FileMainContainer,
    FileUploadContainer,
    FileContainer,
    Title,
    UploadImageContainer,
    AddRecipientContainer,
    InputWithRecipientContainer,
    InputCont,
    Add,
    ErrorContainer,
    ReciepientContainer,
    DocumentSection,
    FileAndReciepientContainer,
    FileLinkContainer,
    FileNameContainer,
    DeleteIconContainer,
    IconBorder,
} from './Discrepancy.styled';
import Input from 'src/common/components/form/input/Input';
import { useDispatch, useSelector } from 'react-redux';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
import { checkPoFileExtension } from 'src/utils/util';
import {
    usageDiscrepancyAttachmentUpload,
    deleteDiscrepancyAttachmentRequest,
    setDiscrepancyEmailIds,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { useTranslation } from 'react-i18next';
import { updateDisAttachmentAction } from 'src/pages/reportUsage/redux/action/actionCreators';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        // margin: 'auto',
        // maxWidth: 500,
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    gridPadBottom: {
        paddingBottom: 8,
    },
}));

const Discrepancy = ({
    discrepencyUpdatedDetails,
    emailInputBoxes,
    setEmailInputBoxes,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [expandedCard, setExpandedCard] = useState({
        discrepancy: true,
    });
    const [warningMsg, setWarningMsg] = useState(false);
    const [warningText, setWarningText] = useState('');
    const [discrepencyFiles, setDiscrepencyFiles] = useState([]);
    const classes = useStyles();
    const { discrepancy } = expandedCard;
    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };
    const mediaSizes = {
        titleArea: 6,
        buttonnsArea: 6,
        xs: 3,
        lg: 2,
    };
    const winWidth = window.innerWidth;
    const { myCaseRefId, discrepancyAttachment, discrepancyDataUpdateLoader } =
        useSelector((state) => state.reportUsageRootReducer);
    const uploadedFilesNames =
        discrepencyUpdatedDetails?.discrepancyDto?.uploadedFileNames
            ?.split(',')
            ?.filter((x) => x !== '');

    const fileInput = useRef(null);
    const onFileChange = (event) => {
        const fileCount = discrepancyAttachment?.length
            ? discrepancyAttachment?.filter((item) => item != '')?.length
            : 0;
        if (event.target.files.length + fileCount <= 5) {
            if (filesValidation(event.target.files)) {
                dispatch(
                    usageDiscrepancyAttachmentUpload({
                        files: event.target.files,
                        myCaseRef: myCaseRefId,
                    })
                );
                setWarningText('');
                setWarningMsg(false);
            }
        } else {
            setWarningText(t('common.max5canbeadded'));
            setWarningMsg(true);
        }
    };

    const filesValidation = (files) => {
        let fileSizeError = false;
        let fileExtensionError = false;
        for (let i = 0; i < files.length; i++) {
            if (!checkPoFileExtension(files[i].name)) {
                fileExtensionError = true;
                setWarningText(
                    t('equity.shipping.pleaseselectextension')
                );
                setWarningMsg(true);
                break;
            }
            if (files[i].size >= 10485760) {
                fileSizeError = true;
                setWarningText(t('equity.shipping.filesixenot20mb'));
                setWarningMsg(true);
                break;
            }
        }

        return !fileExtensionError && !fileSizeError;
    };

    const onAddEmailRecipientHandler = () => {
        let previous = [...emailInputBoxes, { value: '', errorMessage: '' }];
        setEmailInputBoxes(previous);
        dispatch(setDiscrepancyEmailIds(previous));
    };
    const onChangeEmail = (index, value) => {
        const emailInputBox = [...emailInputBoxes];
        emailInputBox[index].value = value;
        setEmailInputBoxes(emailInputBox);
        dispatch(setDiscrepancyEmailIds(emailInputBox));
    };
    const onDeleteClick = (fileName) => {
        const obj = {
            fileName,
        };
        dispatch(deleteDiscrepancyAttachmentRequest(obj));
    };
    useEffectWithErrorLogging(() => {
        if (discrepancyDataUpdateLoader) {
            return;
        }
        if (uploadedFilesNames?.length > discrepancyAttachment?.length) {
            let disAttachment = [];
            disAttachment.push(...uploadedFilesNames);
            dispatch(updateDisAttachmentAction(disAttachment));
            setDiscrepencyFiles(disAttachment);
        } else {
            setDiscrepencyFiles(discrepancyAttachment);
        }
    }, [discrepancyAttachment, discrepencyUpdatedDetails]);
    return (
        <>
            <CollapsableCard id="reportUsage-discrepancyMobile-discrepancy-discrepancyReport"
                title={t('orders.reportsAndInvoice.sendUsageReport.DiscrepancyReport')}
                onClick={() => toggleCard('discrepancy', !discrepancy)}
                isExpanded={discrepancy}
                margin={'0px 0px 10px 0px'}
                padding={'12px'}
            >
                {discrepancy && (
                    <>
                        {discrepencyUpdatedDetails?.discrepancyDto
                            ?.discrepancyEntries &&
                            discrepencyUpdatedDetails?.discrepancyDto?.discrepancyEntries?.map(
                                (item, index) => (
                                    <Box
                                        key={index}
                                        className={classes.paper}
                                        my={1}
                                        bgcolor={'#ffffff'}
                                        boxShadow={2}
                                        borderRadius={6}
                                    >
                                        <Grid sm={6} xs={12}>
                                            <TextWithClicks
                                                classes={classes}
                                                media={mediaSizes}
                                                leftTitle={item.productCFN}
                                                justifyContentVal={'flex-end'}
                                                typeNonTissue={
                                                    item?.salesOrg === 'S002'
                                                        ? 'NT'
                                                        : item?.salesOrg ===
                                                              'S030' && 'T'
                                                }
                                                typeEA={item?.uom}
                                            />
                                            <CustomLabel
                                                fSize={'12px !important'}
                                                paddingRight={'4rem!important'}
                                                color={'#140F4B'}
                                                label={item?.description}
                                                opacity={0.7}
                                            />
                                        </Grid>

                                        <Grid sm={6} xs={12}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent:
                                                        'space-between',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        paddingTop: '10px',
                                                    }}
                                                >
                                                    <Grid
                                                        lg={12}
                                                        md={12}
                                                        sm={12}
                                                        xs={12}
                                                        style={{
                                                            display: 'flex',
                                                        }}
                                                    >
                                                        <Grid
                                                            item
                                                            xs={6}
                                                            lg={6}
                                                            md={6}
                                                            spacing={1}
                                                            alignItems={
                                                                'flex-start'
                                                            }
                                                            justifyContent={
                                                                winWidth >=
                                                                sizes.mediumDevice
                                                                    ? 'space-between'
                                                                    : 'flex-end'
                                                            }
                                                            display={'flex'}
                                                            flexDirection={
                                                                'column'
                                                            }
                                                        >
                                                            <CustomLabel
                                                                fSize={
                                                                    '12px !important'
                                                                }
                                                                color={
                                                                    '#202124'
                                                                }
                                                                fWeight={'bold'}
                                                                paddingRight={
                                                                    '2rem!important'
                                                                }
                                                                marginLeft={
                                                                    '-3px'
                                                                }
                                                                textAlign={
                                                                    'right'
                                                                }
                                                                label={
                                                                    t('reportUsage.review.discrepancy.RowHeaderDesktop.qtyReportedByMedRep')
                                                                }
                                                            />

                                                            <CustomLabel
                                                                fSize={
                                                                    '12px !important'
                                                                }
                                                                color={
                                                                    '#202124'
                                                                }
                                                                fWeight={'bold'}
                                                                paddingRight={
                                                                    '2rem!important'
                                                                }
                                                                marginLeft={
                                                                    '-3px'
                                                                }
                                                                textAlign={
                                                                    'right'
                                                                }
                                                                label={
                                                                    item?.repAdjustedQty
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={6}
                                                            lg={6}
                                                            md={6}
                                                            spacing={1}
                                                            alignItems={
                                                                'flex-start'
                                                            }
                                                            justifyContent={
                                                                winWidth >=
                                                                sizes.mediumDevice
                                                                    ? 'space-between'
                                                                    : 'flex-end'
                                                            }
                                                            display={'flex'}
                                                            flexDirection={
                                                                'column'
                                                            }
                                                        >
                                                            <CustomLabel
                                                                fSize={
                                                                    '12px !important'
                                                                }
                                                                color={
                                                                    '#202124'
                                                                }
                                                                fWeight={'bold'}
                                                                paddingRight={
                                                                    '0rem!important'
                                                                }
                                                                marginLeft={
                                                                    '-3px'
                                                                }
                                                                textAlign={
                                                                    'right'
                                                                }
                                                                label={
                                                                    t('reportUsage.review.discrepancy.RowHeaderDesktop.qtyReportedByMedRep')
                                                                }
                                                            />

                                                            <CustomLabel
                                                                fSize={
                                                                    '12px !important'
                                                                }
                                                                color={
                                                                    '#202124'
                                                                }
                                                                fWeight={'bold'}
                                                                paddingRight={
                                                                    '0rem!important'
                                                                }
                                                                marginLeft={
                                                                    '-3px'
                                                                }
                                                                textAlign={
                                                                    'right'
                                                                }
                                                                label={
                                                                    item?.hospitalQty
                                                                }
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            </div>
                                            <PoInfoView
                                                reviewPage={true}
                                                item={item}
                                            />
                                        </Grid>
                                    </Box>
                                )
                            )}
                        <PriceOverrideAlert
                            margin={'20px 0 20px 7px'}
                            alertMessageMobileMargin={'0 0 17px 4px'}
                        >
                            <AlertMsg
                                mbFontSize={'14px'}
                                header={t(
                                    'reportUsage.discrpancyAlertMessage.UsageDescrepancyMessageHeader'
                                )}
                                message={t(
                                    'reportUsage.discrpancyAlertMessage.UsageDiscrepancyMessage'
                                )}
                            />
                        </PriceOverrideAlert>
                        <FileMainContainer>
                            <FileUploadContainer>
                                <DocumentSection>
                                    <Title mbpaddingTop={'8px'}>
                                        <span>{t('reportUsage.review.discrepancy.DiscrepancyMobile.attachedDocument')}</span>
                                        <span className="asterisk">*</span>
                                    </Title>
                                    <input
                                        onChange={onFileChange}
                                        id="file-upload"
                                        type="file"
                                        // accept=".jpg,.jpeg,.gif,.png,.tif,.tiff,.pdf,.bmp,.msg,.doc,.docx,.xls,.txt,.html"
                                        hidden
                                        ref={fileInput}
                                        multiple
                                    />
                                    <UploadImageContainer
                                        onClick={() =>
                                            fileInput.current &&
                                            fileInput.current.click()
                                        }
                                    >
                                        <label>{t('reportUsage.review.discrepancy.DiscrepancyMobile.uploadLabel')}</label>
                                    </UploadImageContainer>
                                </DocumentSection>
                                {warningMsg && (
                                    <ErrorContainer>
                                        {warningText}
                                    </ErrorContainer>
                                )}
                                <FileContainer>
                                    {discrepencyFiles?.map((file, index) => (
                                        <>
                                            {file != '' && (
                                                <FileLinkContainer key={index}>
                                                    <FileNameContainer className="report-usage-discrepancy-mobile-filename-dt-mask">
                                                        {file}
                                                    </FileNameContainer>
                                                    <DeleteIconContainer
                                                        onClick={() =>
                                                            onDeleteClick(file)
                                                        }
                                                        style={{}}
                                                    >
                                                        <IconBorder style={{}}>
                                                            <img
                                                                src={
                                                                    DeleteLight
                                                                }
                                                                style={{
                                                                    width: 20,
                                                                    height: 20,
                                                                    margin: '6px',
                                                                }}
                                                            />
                                                        </IconBorder>
                                                    </DeleteIconContainer>
                                                </FileLinkContainer>
                                            )}
                                        </>
                                    ))}
                                </FileContainer>
                            </FileUploadContainer>
                            <FileAndReciepientContainer>
                                <Title paddingBtm={'10px'}>
                                    <span>{t('reportUsage.review.discrepancy.DiscrepancyMobile.sendToEmailAddress')}</span>
                                    <span className="asterisk">*</span>
                                </Title>
                                <ReciepientContainer>
                                    {emailInputBoxes?.map((item, index) => (
                                        <>
                                            <AddRecipientContainer
                                                flexDirection={'row'}
                                                alignItems="flex-start"
                                            >
                                                <InputWithRecipientContainer>
                                                    <InputCont key={index}>
                                                        <Input
                                                        id={`email-input-${index}`}
                                                            placeholder={t('reportUsage.review.discrepancy.DiscrepancyMobile.emailAddress')}
                                                            onChange={(event) =>
                                                                onChangeEmail(
                                                                    index,
                                                                    event.target
                                                                        .value
                                                                )
                                                            }
                                                            value={
                                                                item?.value ||
                                                                ''
                                                            }
                                                        />
                                                    </InputCont>
                                                    {item?.errorMessage && (
                                                        <ErrorContainer>
                                                            {item.errorMessage}
                                                        </ErrorContainer>
                                                    )}
                                                    {emailInputBoxes?.length -
                                                        1 ===
                                                        index && (
                                                        <Add
                                                            onClick={
                                                                onAddEmailRecipientHandler
                                                            }
                                                        >
                                                            {t('orders.reportsAndInvoice.requestInvoice.addrecipit')}
                                                        </Add>
                                                    )}
                                                </InputWithRecipientContainer>
                                            </AddRecipientContainer>
                                        </>
                                    ))}
                                </ReciepientContainer>
                            </FileAndReciepientContainer>
                        </FileMainContainer>
                    </>
                )}
            </CollapsableCard>
        </>
    );
};

export default Discrepancy;
